export class Coding {
    static ALPHABET_NUMBER = '2513964078';
    static ALPHABET = '23456789bcdfghjkmnpqrstvwxyzBCDFGHJKLMNPQRSTVWXYZ';
    static ALPHABET_ALL = 'Q4W3cvE5xRiTyu67qw1JKoplaGHLPkjhOYUrtfNMdsASDFIgZXezVB890C2bnm';

    static alphabet(_alphabet) {
        switch (_alphabet) {
            case 'number':
                return this.ALPHABET_NUMBER;
            case 'all':
                return this.ALPHABET_ALL;
            case null:
            case '':
            case false:
            case 'default':
                return this.ALPHABET;
            default:
                return _alphabet;
        }
    }

    static encode(_num = null, _alphabet = null) {
        const alphabet = this.alphabet(_alphabet);

        if (typeof _num !== 'number' && typeof _num !== 'string') {
            return false;
        }

        // Check if it's numeric
        if (isNaN(Number(_num))) {
            return false;
        }

        _num = Number(_num);
        if (_num < 0) {
            return false;
        }

        const length = alphabet.length;
        let str = '';

        if (_num === 0) {
            return alphabet[0];
        }

        while (_num > 0) {
            str = alphabet[_num % length] + str;
            _num = Math.floor(_num / length);
        }

        return str;
    }

    static decode(_str = null, _alphabet = null) {
        if (!this.is(_str, _alphabet)) {
            return false;
        }

        const alphabet = this.alphabet(_alphabet);
        const length = alphabet.length;
        let num = 0;
        const len = _str.length;

        for (let i = 0; i < len; i++) {
            const char = _str[i];
            const index = alphabet.indexOf(char);
            if (index === -1) {
                return false;
            }
            num = num * length + index;
        }

        return num;
    }

    static is(_string, _alphabet = null) {
        if (typeof _string !== 'string' && typeof _string !== 'number') {
            return false;
        }

        _string = String(_string);
        const alphabet = this.alphabet(_alphabet);

        // Create a regex pattern that matches only characters in the alphabet
        const escapedAlphabet = alphabet.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regex = new RegExp(`^[${escapedAlphabet}]+$`);

        return regex.test(_string);
    }
}
